const HeaderTitle = ({title, text}) => {
  return (
    <div className="flex flex-col max-sm:gap-2 gap-4 max-sm:px-4 max-lg:px-10 px-24">
        <h4 className="h4-literata max-sm:text-2xl">{title}</h4>
        {text && <p className="body-jost max-sm:text-sm">{text}</p>}
    </div>
  )
}

export default HeaderTitle;